(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/hooks/assets/javascripts/use-countdown.js') >= 0) return;  svs.modules.push('/components/pool-betting/hooks/assets/javascripts/use-countdown.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useCallback = _React.useCallback,
  useState = _React.useState;
const useCountdown = _ref => {
  let targetDateTime = _ref.targetDateTime,
    beginDateTime = _ref.beginDateTime,
    _ref$intervalInSecs = _ref.intervalInSecs,
    intervalInSecs = _ref$intervalInSecs === void 0 ? 1 : _ref$intervalInSecs;
  const wasCountingDown = useRef(false);
  const timerRef = useRef(null);
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    countdown = _useState2[0],
    setCountdown = _useState2[1];
  const prevCountdownRef = useRef();
  const targetDateTimeValue = new Date(targetDateTime).getTime();
  const beginDateTimeValue = beginDateTime ? new Date(beginDateTime).getTime() : dateFns.sub(new Date(targetDateTimeValue), {
    minutes: 59,
    seconds: 59
  }).getTime();
  const calculateCountdown = useCallback(() => {
    const currentTimeValue = new Date().getTime();
    if ((!beginDateTimeValue || currentTimeValue >= new Date(beginDateTimeValue).getTime()) && currentTimeValue <= targetDateTimeValue) {
      wasCountingDown.current = true;
      const distance = targetDateTimeValue - currentTimeValue;
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(distance % (1000 * 60) / 1000);
      let newCountdown = null;
      if (days) {
        newCountdown = "".concat(days, " dag").concat(days > 1 ? 'ar' : '');
      } else if (hours) {
        newCountdown = "".concat(hours + 1, " timmar");
      } else if (minutes) {
        newCountdown = "".concat(minutes + 1, " minuter");
      } else if (seconds) {
        newCountdown = "".concat(seconds, " sekund").concat(seconds > 1 ? 'er' : '');
      }

      if (prevCountdownRef.current !== newCountdown) {
        setCountdown(newCountdown);
      }
      prevCountdownRef.current = newCountdown;
    } else {
      setCountdown(null);
      clearInterval(timerRef.current); 
    }
  }, [beginDateTimeValue, targetDateTimeValue]);
  useEffect(() => {
    setCountdown(null);
    const initializeCountdown = () => {
      calculateCountdown();
      timerRef.current = setInterval(calculateCountdown, intervalInSecs * 1000);
    };
    const now = new Date().getTime();
    if (now < beginDateTimeValue) {
      const delay = beginDateTimeValue - now;
      timerRef.current = setTimeout(initializeCountdown, delay);
    } else {
      initializeCountdown();
    }
    return () => {
      clearInterval(timerRef.current);
      clearTimeout(timerRef.current);
    };
  }, [beginDateTimeValue, calculateCountdown]);
  return countdown;
};
setGlobal('svs.components.poolBetting.hooks.useCountdown', useCountdown);

 })(window);